import AppRouter from './AppRouter';
import { NameDropProvider } from './context/NameDropContext';
import './global.css';

function App() {
  // useEffect(() => {
  //   const favicon = document.getElementById('favicon') as HTMLLinkElement | null;

  //   if (!favicon) return;

  //   const updateFavicon = (e: MediaQueryListEvent | MediaQueryList) => {
  //     favicon.href = e.matches ? 'favicon-dark.ico' : 'favicon-light.ico';
  //   };

  //   const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
  //   updateFavicon(darkModeMediaQuery); // Initial favicon setup
  //   darkModeMediaQuery.addEventListener('change', updateFavicon); // Listen for changes

  //   return () => {
  //     darkModeMediaQuery.removeEventListener('change', updateFavicon);
  //   };
  // }, []);

  return (
    <>
      <NameDropProvider>
        <AppRouter />
      </NameDropProvider>
    </>
  );
}

export default App;
